'use client';

import { c as _c } from "react/compiler-runtime";
import type { Node } from '@/components/ui/tree-view';
import { createTreeCollection, TreeView as UITreeView } from '@/components/ui/tree-view';
type TreeViewProps = {
  collection: Node;
} & Omit<React.ComponentProps<typeof UITreeView>, 'collection'>;
export function TreeView(props) {
  const $ = _c(8);
  let collection;
  let rest;
  if ($[0] !== props) {
    ({
      collection,
      ...rest
    } = props);
    $[0] = props;
    $[1] = collection;
    $[2] = rest;
  } else {
    collection = $[1];
    rest = $[2];
  }
  let t0;
  if ($[3] !== collection) {
    t0 = createTreeCollection({
      nodeToValue: _temp,
      nodeToString: _temp2,
      rootNode: collection
    });
    $[3] = collection;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  let t1;
  if ($[5] !== rest || $[6] !== t0) {
    t1 = <UITreeView collection={t0} {...rest} />;
    $[5] = rest;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}
function _temp2(node_0) {
  return node_0.name;
}
function _temp(node) {
  return node.id;
}